export default "__VITE_ASSET__dc2f66da__"